const state = {
  users: {
    isLoading: false,
    many: {},
    one: null,
  },
};

export default state;
